import { useEffect, useState } from "react";
import { FaFileInvoice, FaSpinner } from "react-icons/fa";
import Collabse from "../../../components/Collabse";
import { useAppSelector } from "../../../redux/store";
import getDocuments from "../../../services/getDocuments";
import SingleDocument from "./SingleDocument";
import { useTranslation } from "react-i18next";

const Documents = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const isCanceled = booking.isCanceled;

  const [documents, setDocuments] = useState<any>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!booking.customerId || isAgency) {
      return;
    }

    getDocuments(
      booking.bookingNumber,
      booking.customerId.toString(),
      booking.orderId.toString(),
      booking.orgunit
    ).then((data) => {
      setDocuments(data);
      setLoading(false);
    });
  }, [booking]);

  if (isAgency) return null;

  return (
    <Collabse Header={Header}>
      {loading && <FaSpinner icon="spinner" className="spinner" />}

      {documents && Object.keys(documents).length > 0 ? (
        <ul style={{ listStyle: "none" }} className="d-flex gap-3">
          {documents.aktuelleRechnung && (
            <SingleDocument
              documentContent={documents.aktuelleRechnung.documentContent}
              documentName="Aktuelle Rechnung"
            />
          )}

          {!isCanceled && documents.zahlungsbeleg && (
            <SingleDocument
              documentContent={documents.zahlungsbeleg.documentContent}
              documentName="Zahlungsbeleg"
            />
          )}

          {!isCanceled && documents.reiseplan && (
            <SingleDocument
              documentContent={documents.reiseplan.documentContent}
              documentName="Reiseunterlagen"
            />
          )}

          {!isCanceled && documents.voucher && (
            <SingleDocument
              documentContent={documents.voucher.documentContent}
              documentName="voucher"
            />
          )}

          {!isCanceled && documents.reiseinformationen && (
            <SingleDocument
              documentContent={documents.reiseinformationen.documentContent}
              documentName="Reiseinformationen"
            />
          )}
        </ul>
      ) : (
        <>{!loading && <p>Keine Reisedokumente vorhanden.</p>}</>
      )}
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();
  return (
    <h5>
      <FaFileInvoice />
      {t("bookingDetails.documents.title")}
    </h5>
  );
};

export default Documents;
